import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Authentication.module.scss";
//Icon
import ArrowBackIcon from "../../../../styles/icon/arrow_back_fill.svg";
import IdCardIcon from "../../../../styles/icon/idcardgray.svg";
import AttachIcon from "../../../../styles/icon/AttachmentIcon.svg";
import { usersVerifyInfo } from "../../../../services/userServices";
import { uploadAuthUserFiles } from "../../../../services/adminServices";
import { checkFileTypeImage } from "../../../Validator/Validator";
import { errorMessage, successMessage } from "../../../../utils/messages";
import { ERROR_CODE9 } from "../../../Validator/ErrorCodes";
export default function PersonCardId() {
  //Functions
  const history = useHistory();
  //State's
  const [docInfo, setDocInfo] = useState("");
  const [idCardUploadInfo, setIdCardUploadInfo] = useState({
    file: "",
    deactivateButton: false,
  });
  useEffect(() => {
    const getVerifyInforamtion = async () => {
      const verifyInfo = await usersVerifyInfo();
      if (verifyInfo.data.message) setDocInfo(verifyInfo.data.user);
    };
    getVerifyInforamtion();
  }, []);
  const handleSendUserIdCard = async (e) => {
    e.preventDefault();
    if (!idCardUploadInfo.file) return errorMessage("فایلی انتخاب نشده");
    let validFileType = checkFileTypeImage(idCardUploadInfo.file.name);
    if (!validFileType) return errorMessage(ERROR_CODE9);
    try {
      setIdCardUploadInfo({ ...idCardUploadInfo, deactivateButton: true });
      const data = new FormData();
      data.append("fileType", "IDCARD");
      data.append("file", idCardUploadInfo.file);
      const info = await uploadAuthUserFiles(data);
      if (info.status === 200) {
        successMessage(info.data.message);
        setIdCardUploadInfo({ ...idCardUploadInfo, file: "" });
        history.replace("/my-profile/authentication");
      }
    } catch (ex) {
      errorMessage("مشکلی در آپلود رخ داده! دوباره تلاش کنید");
    } finally {
      setIdCardUploadInfo({
        ...idCardUploadInfo,
        deactivateButton: false,
      });
    }
  };
  if (docInfo.userIdCard === "UNCHECKED" || docInfo.userIdCard === "APPROVED") {
    history.replace("/my-profile/authentication");
    return null;
  }
  return (
    <>
      <section className={styles.container_of_id_card}>
        <header>
          <div className={styles.back}>
            <img
              src={ArrowBackIcon}
              alt="BACK"
              width={15}
              height={15}
              onClick={() => history.push("/my-profile/authentication")}
              className="convertPicToWhite"
            />
          </div>
          <div className={`font_color_white ${styles.header_title}`}>
            مدارک احراز هویت
          </div>
        </header>
        <main>
          <div className={`font_color_white ${styles.header_of_main_title}`}>
            آپلود تصویر کارت ملی
          </div>
          <div className={`font_color_white ${styles.guide_to_send_files}`}>
            عکس از کارت ملی یا کارت اصل شناسنامه یا اصل پاسپورت با حداقل اعتبار
            یک ساله ارسال نمایید لازم به ذکر است رسید کارت ملی پذیرفته شده نمی
            باشد.
          </div>
          <form onSubmit={(e) => handleSendUserIdCard(e)}>
            <div className={styles.section_of_input}>
              <label htmlFor="uploadIdCardAuthentication">
                <div className={styles.label_for_input_file}>
                  <div className={styles.icon_card}>
                    <img src={IdCardIcon} alt="" width={40} height={40} />
                  </div>
                  <div className={styles.text_icon_card}>
                    <div className="font_color_white">
                      انتخاب تصویر کارت ملی
                    </div>
                    <div>
                      <img
                        src={AttachIcon}
                        alt=""
                        width={18}
                        height={18}
                        className="convertPicToGreen"
                      />
                    </div>
                  </div>
                </div>
                <input
                  type="file"
                  id="uploadIdCardAuthentication"
                  onChange={(e) =>
                    setIdCardUploadInfo({
                      ...idCardUploadInfo,
                      file: e.target.files[0],
                    })
                  }
                />
              </label>
            </div>
            <div className={styles.pic_uploaded_info}>
              {idCardUploadInfo.file && (
                <>
                  <div>{idCardUploadInfo.file.name}</div>
                  {!idCardUploadInfo.deactivateButton && (
                    <div
                      onClick={() =>
                        setIdCardUploadInfo({ ...idCardUploadInfo, file: "" })
                      }
                    >
                      پاک کردن عکس
                    </div>
                  )}
                </>
              )}
            </div>
            <div className={styles.button_container}>
              <button
                type="submit"
                disabled={idCardUploadInfo.deactivateButton}
              >
                ارسال
              </button>
            </div>
          </form>
        </main>
      </section>
    </>
  );
}
